import React from "react";
import { Typography } from "@mui/material";
import { UserContext } from "../contexts/userContext";
import { useNavigate } from "react-router-dom";

export const Logo = () => {
  const navigate = useNavigate();
  const userContext = React.useContext(UserContext);

  const url = userContext.user.id
    ? `/${userContext.user.id}/projects`
    : "/login";

  return (
    <Typography
      variant="h6"
      noWrap
      component="div"
      onClick={() => navigate(url)}
      sx={{
        mr: 2,
        display: { xs: "flex", md: "flex" },
        fontFamily: "monospace",
        fontWeight: 700,
        fontSize: "1.5rem",
        letterSpacing: ".3rem",
        color: "inherit",
        textDecoration: "none",
        cursor: "pointer",
      }}
    >
      SjorCRAFT
    </Typography>
  );
};
